import { Field, Label, Radio } from '@headlessui/react';
import PropTypes from 'prop-types';

function SimpleRadio({ option, label }) {
  return (
    <>
      <Field key={option.id} className="flex items-center gap-2">
        <Radio
          value={option.value}
          className="group flex size-5 items-center justify-center rounded-full border bg-event-deep border-event-muted data-[checked]:border-event-light data-[checked]:bg-event-tertiary"
        >
          <span className="invisible size-2 rounded-full bg-white group-data-[checked]:visible" />
        </Radio>
        <Label className={'text-event-light'}>{label}</Label>
      </Field>
    </>
  );
}

SimpleRadio.propTypes = {
  label: PropTypes.string.isRequired,
  option: PropTypes.shape({
    id: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};

export default SimpleRadio;
